// src/components/noticias/NoticiasNav.js
import React from 'react';
import { NavLink } from 'react-router-dom';

const TIPOS_NOTICIAS = ['ROSTERS', 'COLABORACIONES', 'MERCHANDISING'];

function NoticiasNav() {
  return (
    <div className="sticky top-20 z-40 mb-12 bg-brand-dark/95 backdrop-blur-sm">
      <div className="container mx-auto px-4">
        <div className="flex flex-wrap gap-2 p-2 justify-center">
          <NavLink
            to="/noticias"
            end
            className={({ isActive }) =>
              `px-8 py-2 text-3xl font-morganite tracking-wider transition-all duration-300 ${
                isActive 
                  ? 'text-brand-peach bg-brand-red/20' 
                  : 'text-brand-white/70 hover:text-brand-white hover:bg-brand-red/10'
              } rounded-lg`
            }
          >
            TOYO
          </NavLink>
          {TIPOS_NOTICIAS.map((tipo) => (
            <NavLink
              key={tipo}
              to={`/noticias/tipo/${tipo.toLowerCase()}`}
              className={({ isActive }) =>
                `px-8 py-2 text-3xl font-morganite tracking-wider transition-all duration-300 ${
                  isActive 
                    ? 'text-brand-peach bg-brand-red/20' 
                    : 'text-brand-white/70 hover:text-brand-white hover:bg-brand-red/10'
                } rounded-lg`
              }
            >
              {tipo}
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}

export default NoticiasNav;